import service from './serviceFactory'

export default {
  submit: data => service().post('sendMail', data)
}
